import React, { useEffect, useState } from "react";
import Menusidebar from "../components/Element/Menusidebar";
import AccountCentreSidebar from "../components/Element/AccountCentreSidebar";
import { isMobileOrLaptop } from "../services/CheckDevice";
import MenuSideBarMobile from "../components/Element/MenuSideBarMobile";
import PoliciesAndProceduresDetails from "../components/Element/PoliciesAndProcedures/PoliciesAndProceduresDetails";
import IdCard from "./candidate-identity-card/IdCard";
const IdCardPage = (props) => {
  // Check Device - Start
  const [checkDevice, setCheckDevice] = useState("Mobile");

  window.addEventListener("resize", function () {
    // Call the function when the screen size changes
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop(350);
    setCheckDevice(deviceType);
  }, []);
  // Check Device - End
  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                {checkDevice == "Mobile" ? (
                  <MenuSideBarMobile page="identity-card" />
                ) : (
                  <Menusidebar page="identity-card" />
                )}

                <div className="col-xl-9 col-lg-8 m-b30">
                  <IdCard deviceInfo={checkDevice} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default IdCardPage;
